var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{staticClass:"ais-ClearRefinements"},[_c('button',{staticClass:"ais-ClearRefinements-button",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.refine.apply(null, arguments)}}},[_vm._v(" Reset filters ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }